const Loader = () => {
    return (
      <div className="flex h-screen items-center justify-center bg-white  z-50 bg-opacity-25">
        <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent "></div>
      </div>
    );
  };
  
  export default Loader;

export const LoadingBersama = () => {
  return(
    <div className={`h-screen w-screen absolute top-0 left-0 bg-slate-400 opacity-70 z-999 rounded-md text-center flex justify-center items-center cursor-none`}><img className="h-32 w-32  animate-bounce" src="/logokucing.png" alt=""/></div>
  )
}
  